import React from 'react';
import PropTypes from 'prop-types';
import {Button} from './Button';
import {PowerSupplyContext} from '../../../../..';

import './style.scss';

/**
 * ButtonControls:
 *   to render the button controls in settings
 */
export function ButtonControls(props) {
  const {power} = React.useContext(PowerSupplyContext);

  const onClickIncrement = () => power && props.increment();
  const onClickDecrement = () => power && props.decrement();

  const onKeyPressIncrement = (event) => {
    if (event.code == 'Enter' || event.code == 'Space') {
      onClickIncrement()
    }
  }

  const onkeyPressDecrement = (event) => {
    if (event.code == 'Enter' || event.code == 'Space') {
      onClickDecrement()
    }
  }

  return (
    <div className='mc_settings_buttonControl'>
      <Button onClick={onClickIncrement} onKeyPress={onKeyPressIncrement} disabled={!power}  altText={props.altText1} />
      <span className='mc_settings_buttonControl_text'>{props.text}</span>
      <Button rotate={true} onClick={onClickDecrement} onKeyPress={onkeyPressDecrement} disabled={!power} altText={props.altText2} />
    </div>
  );
}

ButtonControls.propTypes = {
  /**
   * callback to trigger on click of top button (increment button)
   */
  increment: PropTypes.func,
  /**
   * callback to trigger on click of bottom button (decrement button)
   */
  decrement: PropTypes.func,
  /**
   * text displayed between both buttons
   */
  text: PropTypes.string,
};

ButtonControls.defaultProps = {
  text: '',
};
